module.exports = __webpack_public_path__ + "img/round-close.84e833e5.svg";